// Angular
import {Component, Input, OnInit, ViewEncapsulation} from '@angular/core';

export const DOWNLOADABLE_LINKS = 'downloadableLinks';

@Component({
	selector: 'cv-download-link',
	encapsulation: ViewEncapsulation.None,
	templateUrl: './download-link.component.html',
	styleUrls: ['./download-link.component.scss']
})
export class DownloadLinkComponent implements OnInit {
	@Input() downloadableLink = '';

	ngOnInit(): void {
		this.downloadFile();
	}

	/**
	 * Create an iFrame on fly to download the file
	 */
	public downloadFile(): void {
		let iframe: any = document.getElementById('hidden-downloader-iframe');
		if (iframe === null) {
			iframe = document.createElement('iframe');
			iframe.id = 'hidden-downloader-iframe';
			iframe.style.visibility = 'hidden';
			iframe.style.width = '0px';
			iframe.style.height = '0px';
			iframe.style.display = 'none';
			document.body.appendChild(iframe);
		}
		iframe.src = this.downloadableLink;
	}
}
